export enum ProductTypeEnum {
  TRACK = 'track',
  ALBUM = 'album',
  LINK = 'link',
  MERCH = 'merch',
  VIDEO = 'video',
  LIVESTREAM = 'livestream',
  EVENT = 'event',
  TOUR = 'tour',
  TICKET = 'ticket',
  MEETING = 'meeting',
}
